export const normalizeTeacherName = (value) => String(value || '').trim()
